import Vue from 'vue'
import VueRouter from 'vue-router'

// import Chart from '../components/Chart.vue'
import Login from '../components/Login.vue'
import Nav from '../components/Nav.vue'

Vue.use(VueRouter)

const routes = [
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'charts',
    path: '/charts',
    component: Nav
  },
  {
    name: '/',
    path: '/',
    redirect: '/charts'
  }
]

const router = new VueRouter({
  routes
})

export default router
